import { createRouter, createWebHistory } from "vue-router";
import { trackPageView } from "@/utils/analytics";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
    meta: {
      title:
        "Crypto & Gaming License Consulting + Company Formation | Somani Global",
      description:
        "Somani Global helps you obtain crypto licenses, gaming licenses and register companies across 20+ jurisdictions, with expert end-to-end compliance support.",
    },
  },
  {
    path: "/contact",
    name: "ContactUs",
    component: () => import("../views/ContactUs.vue"),
    meta: {
      title: "Contact Somani Global — Crypto, Gaming & Company Licensing Experts",
      description:
        "Talk to Somani Global about crypto licensing, gaming licenses and company registration. Experts respond within 24 hours. Offices in Mumbai and New York.",
    },
  },
  {
    path: "/thank-you",
    name: "ThankYou",
    component: () => import("../views/ThankYou.vue"),
    meta: {
      title: "Thank You | Somani Global",
      description:
        "Your message has been received. Our team will respond within 24 hours.",
      noindex: true,
    },
  },
  // {
  //   path: "/services/audit-compliance",
  //   name: "AuditCompliance",
  //   component: () => import("../views/services/AuditCompliance.vue"),
  // },
  {
    path: "/services/company-registration/:country",
    name: "CompanyRegistration",
    component: () =>
      import("../views/services/company-registration/[country].vue"),
    props: (route) => ({ country: route.params.country, ...route.query }), // ✅ Pass query as props
  },
  {
    path: "/services/crypto-license/canada",
    name: "CryptoLicenseCanada",
    component: () =>
      import("@/views/services/crypto-license/CryptoLicenseinCanada.vue"),
    meta: {
      title: "Crypto License in Canada (MSB) — Requirements & Cost | Somani Global",
      description:
        "Get a crypto (MSB) license in Canada with Somani Global. We guide you through requirements, costs, timelines and AML compliance with full remote support.",
    },
  },
  {
    path: "/services/crypto-license/singapore",
    name: "CryptoLicenseSingapore",
    component: () =>
      import("@/views/services/crypto-license/CryptoLicenseinSingapore.vue"),
    meta: {
      title: "Crypto License in Singapore — Requirements & Cost | Somani Global",
      description:
        "Obtain a crypto license in Singapore (MAS / PSA) with Somani Global. Expert help with requirements, costs, timelines and compliance, end-to-end.",
    },
  },
  {
    path: "/services/crypto-license/varadubai",
    name: "CryptoLicenseDubaiVARA",
    component: () =>
      import("@/views/services/crypto-license/CryptoLicenseinDubaiVARA.vue"),
    meta: {
      title: "Dubai VARA Crypto License — Requirements & Cost | Somani Global",
      description:
        "Apply for a Dubai VARA crypto license with Somani Global. We handle requirements, costs, timelines and VARA compliance from start to finish.",
    },
  },
  {
    path: "/services/crypto-license/dubai",
    name: "CryptoLicenseDubai",
    component: () =>
      import("@/views/services/crypto-license/CryptoLicenseinDubai.vue"),
    meta: {
      title: "Crypto License in Dubai (UAE) — Requirements & Cost | Somani Global",
      description:
        "Get a crypto license in Dubai, UAE with Somani Global. Expert guidance on requirements, costs, free zones, timelines and compliance, end-to-end.",
    },
  },
  {
    path: "/services/crypto-license/estonia",
    name: "CryptoLicenseEstonia",
    component: () =>
      import("@/views/services/crypto-license/CryptoLicenseinEstonia.vue"),
    meta: {
      title: "Crypto License in Estonia — Requirements & Cost | Somani Global",
      description:
        "Obtain an Estonia crypto license with Somani Global. We guide you through requirements, costs, timelines and AML compliance with full remote support.",
    },
  },
  {
    path: "/services/crypto-license/lithuania",
    name: "CryptoLicenseLithuania",
    component: () =>
      import("@/views/services/crypto-license/CryptoLicenseinLithuania.vue"),
    meta: {
      title: "Crypto License in Lithuania — Requirements & Cost | Somani Global",
      description:
        "Get a crypto license in Lithuania (EU) with Somani Global. Expert help with requirements, costs, timelines and AML compliance, end-to-end support.",
    },
  },
  {
    path: "/services/crypto-license/czechrepublic",
    name: "CryptoLicenseCzechRepublic",
    component: () =>
      import(
        "@/views/services/crypto-license/CryptoLicenseinCzechRepublic.vue"
      ),
    meta: {
      title:
        "Crypto License in the Czech Republic — Requirements & Cost | Somani Global",
      description:
        "Obtain a Czech Republic crypto license with Somani Global. We handle requirements, costs, timelines and EU compliance from start to finish.",
    },
  },
  {
    path: "/services/crypto-license/elsalvador",
    name: "CryptoLicenseElSalvador",
    component: () =>
      import("@/views/services/crypto-license/CryptoLicenseinElSalvador.vue"),
    meta: {
      title: "Crypto License in El Salvador — Requirements & Cost | Somani Global",
      description:
        "Get an El Salvador crypto / digital asset license with Somani Global. Expert guidance on requirements, costs, timelines and compliance, end-to-end.",
    },
  },
  {
    path: "/services/crypto-license/tbilisifreezone",
    name: "CryptoLicenseTbilisiFreeZone",
    component: () =>
      import(
        "@/views/services/crypto-license/CryptoLicenseinTbilisiFreeZone.vue"
      ),
    meta: {
      title:
        "Crypto License in Tbilisi Free Zone (Georgia) — Cost | Somani Global",
      description:
        "Obtain a crypto license in the Tbilisi Free Zone, Georgia with Somani Global. We guide you through requirements, costs, timelines and compliance.",
    },
  },
  {
    path: "/services/crypto-license/micaregulation",
    name: "CryptoLicenseMICARegulation",
    component: () =>
      import("@/views/services/crypto-license/CryptoLicensewithMICA.vue"),
    meta: {
      title: "Crypto License under MiCA Regulation (EU) | Somani Global",
      description:
        "Get an EU crypto-asset (CASP) license under MiCA with Somani Global. Expert help with requirements, costs, timelines and MiCA compliance, end-to-end.",
    },
  },
  {
    path: "/services/crypto-license/poland",
    name: "CryptoLicensePoland",
    component: () =>
      import("@/views/services/crypto-license/CryptoLicenseinPoland.vue"),
    meta: {
      title: "Crypto License in Poland — Requirements & Cost | Somani Global",
      description:
        "Obtain a Poland crypto / VASP license with Somani Global. We guide you through requirements, costs, timelines and AML compliance, end-to-end.",
    },
  },
  {
    path: "/services/crypto-license/mauritius",
    name: "CryptoLicenseMauritius",
    component: () =>
      import("@/views/services/crypto-license/CryptoLicenseinMauritius.vue"),
    meta: {
      title: "Crypto License in Mauritius — Requirements & Cost | Somani Global",
      description:
        "Get a Mauritius crypto / VASP license with Somani Global. Expert guidance on requirements, costs, timelines and compliance with full remote support.",
    },
  },
  {
    path: "/services/gaming-license/indian",
    name: "IndianGamingLicense",
    component: () =>
      import("@/views/services/gaming-license/IndianGamingLicense.vue"),
    meta: {
      title: "Indian Gaming License — Requirements & Cost | Somani Global",
      description:
        "Obtain a gaming / gambling license in India with Somani Global. Expert help with requirements, costs, timelines and compliance, end-to-end support.",
    },
  },
  {
    path: "/services/gaming-license/anjouan",
    name: "AnjouanGamingLicense",
    component: () =>
      import("@/views/services/gaming-license/AnjouanGamingLicense.vue"),
    meta: {
      title: "Anjouan Gaming License — Requirements & Cost | Somani Global",
      description:
        "Get an Anjouan gaming / gambling license with Somani Global. We handle requirements, costs, timelines and compliance from start to finish.",
    },
  },
  {
    path: "/services/gaming-license/costa-rica",
    name: "CostaRicaGamingLicense",
    component: () =>
      import("@/views/services/gaming-license/CostaRicaGamingLicense.vue"),
    meta: {
      title: "Costa Rica Gaming License — Requirements & Cost | Somani Global",
      description:
        "Obtain a Costa Rica gaming / gambling license with Somani Global. Expert guidance on requirements, costs, timelines and compliance, end-to-end.",
    },
  },
  {
    path: "/services/gaming-license/malta",
    name: "MaltaGamingLicense",
    component: () =>
      import("@/views/services/gaming-license/MaltaGamingLicense.vue"),
    meta: {
      title: "Malta Gaming License (MGA) — Requirements & Cost | Somani Global",
      description:
        "Get a Malta (MGA) gaming license with Somani Global. We guide you through requirements, costs, timelines and MGA compliance, end-to-end support.",
    },
  },
  {
    path: "/services/gaming-license/portugal",
    name: "PortugalGamingLicense",
    component: () =>
      import("@/views/services/gaming-license/PortugalGamingLicense.vue"),
    meta: {
      title: "Portugal Gaming License — Requirements & Cost | Somani Global",
      description:
        "Obtain a Portugal gaming / gambling license with Somani Global. Expert help with requirements, costs, timelines and compliance, end-to-end.",
    },
  },
  {
    path: "/services/gaming-license/panama",
    name: "PanamaGamingLicense",
    component: () =>
      import("@/views/services/gaming-license/PanamaGamingLicense.vue"),
    meta: {
      title: "Panama Gaming License — Requirements & Cost | Somani Global",
      description:
        "Get a Panama gaming / gambling license with Somani Global. We handle requirements, costs, timelines and compliance from start to finish.",
    },
  },
  {
    path: "/services/gaming-license/romania",
    name: "RomaniaGamingLicense",
    component: () =>
      import("@/views/services/gaming-license/RomaniaGamingLicense.vue"),
    meta: {
      title: "Romania Gaming License (ONJN) — Requirements & Cost | Somani Global",
      description:
        "Obtain a Romania (ONJN) gaming license with Somani Global. Expert guidance on requirements, costs, timelines and compliance, end-to-end support.",
    },
  },
  // {
  //   path: "/about-us",
  //   name: "AboutUs",
  //   component: () => import("../views/AboutUs.vue"),
  // },
  // {
  //   path: "/services",
  //   name: "Services",
  //   component: () => import("../views/services/Services.vue"),
  // },
  // {
  //   path: "/products",
  //   name: "Products",
  //   component: () => import("../views/Products.vue"),
  // },
  // {
  //   path: "/industries",
  //   name: "Industries",
  //   component: () => import("../views/Industries.vue"),
  // },
  // {
  //   path: "/insights",
  //   name: "Insights",
  //   component: () => import("../views/Insights.vue"),
  // },
  // {
  //   path: "/careers",
  //   name: "Careers",
  //   component: () => import("../views/Careers.vue"),
  // },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ left: 0, top: 0 });
      }, 0);
    });
  },
});

// Send a GA4 page_view on every SPA navigation (including the first). No-op
// during prerender and when analytics is unavailable.
router.afterEach((to) => {
  trackPageView(to.fullPath, to.meta && to.meta.title);
});

export default router;
